import { useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

/** Members connected to this store's chat; `presence.updated` frames invalidate it. */
export function useChatPresence(storeId: string) {
  return useQuery({
    queryKey: conversationKeys.presence(storeId),
    queryFn: () => conversationsApi.presence(storeId),
    staleTime: 30_000,
  });
}
